import { UserFrontPage } from '@psl/flows/me/UserFrontPage';
import { ScreenToParams } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

export const userFrontScreens = {
  main: UserFrontPage,
};

export type UserFrontScreensParams = ScreenToParams<typeof userFrontScreens>;

export const useUserFrontNavigation = () =>
  useNavigation<StackNavigationProp<UserFrontScreensParams>>();
